import { z } from "zod";

/**
 * InspecaoMaquinaEquipSchema
 */

export const InspecaoMaquinaEquipSchema = z.object({
  idInspecaoMaquinaEquip: z.number().optional().nullable(),
  idFuncionarioInspecionado: z.number().nullable().default(null),
  idFuncionarioAprovado: z.number().nullable().default(null),
  status: z.number().nullable().default(null),
  dataEncerramento: z.coerce.date().nullable().default(null),
  descricaoProblema: z.string().nullable().default(null),
  correcaoProblema: z.string().nullable().default(null),
  nomearquivo1: z.string().nullable().default(null),
  nomearquivo2: z.string().nullable().default(null),
  arquivo1: z.instanceof(File).nullable().default(null),
  arquivo2: z.instanceof(File).nullable().default(null),
  limparArquivo1: z.boolean().default(false),
  limparArquivo2: z.boolean().default(false),
  itens: z.array(z.object({
    idInspecaoMaquinaEquipItens: z.number(),
    descricao: z.string(),
    inspecao1: z.string().default(""),
    inspecao2: z.string().default(""),
  })).nullable().default(null),
})
  .superRefine((data, ctx) => {
    const temPendencia = data.itens?.some((item) => item.inspecao1 === "P" || item.inspecao1 === "C");

    if (temPendencia) {
      if (!data.descricaoProblema?.trim()) {
        ctx.addIssue({
          path: ["descricaoProblema"],
          code: z.ZodIssueCode.custom,
          message: "Descrição do problema é obrigatória quando houver P ou C",
        });
      }

      if (!data.correcaoProblema?.trim()) {
        ctx.addIssue({
          path: ["correcaoProblema"],
          code: z.ZodIssueCode.custom,
          message: "Correção do problema é obrigatória quando houver P ou C",
        });
      }
    }
  });

/**
 * InspecaoMaquinaEquipForm
 */

export type InspecaoMaquinaEquipForm = z.infer<typeof InspecaoMaquinaEquipSchema>;
